import React from 'react';

import PropTypes from 'prop-types';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import Actions from './Actions';
import { getStatus, getLocalFormattedTime } from './utils';

const Row = ({ order, index, fetchOrders }) => {
  const { orderId, businessLegalName, productInOrderFor, createdAt } = order;
  const { statusId, statusToolTip } = getStatus(order);

  return (
    <Tr
      style={{
        background: index % 2 === 0 ? '#f9f1ff' : '#ffffff'
      }}
    >
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{orderId}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7', textAlign: 'center' }}>
        {businessLegalName}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7', textAlign: 'center' }}>
        {productInOrderFor}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {getLocalFormattedTime(createdAt)}
      </Td>
      <Td
        style={{
          borderRight: '1px solid #e7e7e7',
          width: '5%',
          textAlign: 'center'
        }}
      >
        {statusToolTip}
      </Td>
      <Td
        style={{
          width: '15%',
          borderRight: '1px solid #e7e7e7',
          textAlign: 'center'
        }}
      >
        New
      </Td>
      <Td style={{ width: '20%', borderRight: '1px solid #e7e7e7' }}>
        <Actions status={statusId} order={order} fetchOrders={fetchOrders} />
      </Td>
    </Tr>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Row;
